import { TROPHY_ICON } from "@/components/layout/nav-config";
import { cn } from "@/lib/cn";

/**
 * Branded loading state. Used anywhere a page or session is resolving so the
 * user sees the STEP-TEMBER mark rather than a bare spinner or, worse, a
 * flash of the previous screen.
 */
export function BrandLoader({
  label = "Loading",
  fullScreen = false,
  className,
}: {
  label?: string;
  fullScreen?: boolean;
  className?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "flex flex-col items-center justify-center gap-5",
        fullScreen ? "min-h-[100dvh] w-full" : "min-h-[50vh] w-full",
        className,
      )}
    >
      <span className="relative flex h-16 w-16 items-center justify-center">
        {/* Sweeping ring */}
        <span
          aria-hidden="true"
          className="absolute inset-0 animate-spin rounded-full border-[3px] border-[var(--brand-primary)]/15 border-t-[var(--brand-accent)]"
          style={{ animationDuration: "900ms" }}
        />
        {/* Brand mark */}
        <span className="brand-gradient flex h-11 w-11 animate-pulse items-center justify-center rounded-2xl text-white shadow-[var(--shadow-accent)]">
          <TROPHY_ICON className="h-6 w-6" />
        </span>
      </span>

      <div className="flex flex-col items-center gap-1.5">
        <span className="text-sm font-bold uppercase tracking-[0.18em] text-text-muted">
          STEP&#8209;TEMBER
        </span>
        <span className="text-sm text-text-subtle">{label}</span>
      </div>
    </div>
  );
}
